import Button from "@mui/material/Button";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AlertIcon from "@mui/icons-material/ErrorOutline";

const FilterWarningPrompt = ({
  apply,
  discard,
}: {
  apply: () => void;
  discard: () => void;
}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: 360,
          height: 410,
          backgroundColor: "white",
          borderRadius: 9,
          borderColor: "#09B0F2",
          borderStyle: "solid",
          borderWidth: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            height: 60,
            minHeight: 60,
            borderTopLeftRadius: 6,
            borderTopRightRadius: 6,
            backgroundColor: "#09B0F2",
            color: "white",
            display: "flex",
            alignItems: "center",
            paddingLeft: 20,
            fontSize: 20,
            fontWeight: 700,
          }}
        >
          Unapplied Filter Changes
        </div>

        {/* BODY */}
        <div
          style={{
            height: "100%",
            padding: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexGrow: 1,
            gap: 15,
          }}
        >
          <AlertIcon style={{ color: "#C52F00", fontSize: 70 }} />

          <div
            style={{
              color: "black",
              textAlign: "center",
              fontSize: 20,
              fontWeight: 700,
            }}
          >
            Are you sure you do not want to apply filter changes?
          </div>

          <div
            style={{
              color: "#878787",
              textAlign: "center",
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            Any filter changes made will not be applied.
          </div>
        </div>

        {/* FOOTER */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
            paddingBottom: 30,
          }}
        >
          <Button
            id="filterWarningDiscard"
            variant="outlined"
            onClick={discard}
          >
            <CloseIcon />
            DISCARD
          </Button>
          <Button
            id="filterWarningApply"
            variant="contained"
            color="primary"
            onClick={apply}
          >
            <CheckIcon />
            APPLY
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterWarningPrompt;
